import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://wnorwwdtztclosrjqpli.supabase.co';

// For Create React App, environment variables must be prefixed with REACT_APP_
// Make sure your .env file has REACT_APP_SUPABASE_ANON_KEY=your_key
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indub3J3d2R0enRjbG9zcmpxcGxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjI1OTk2MzcsImV4cCI6MjA3ODE3NTYzN30.y357lnt6sYclgwHd61s9KJ-FMA6VHepLEUBNRLBzBao";

export const supabase = createClient(supabaseUrl, supabaseKey);
